import SvgIcon from "@mui/material/SvgIcon";

interface AnimalsPawIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function AnimalsPawIcon({
  htmlColor,
  fontSize = "medium",
}: AnimalsPawIconProps) {
  return (
    <SvgIcon viewBox="0 0 14 14" fontSize={fontSize}>
      <path
        d="M2.57304 9.77167C2.43304 11.4575 3.7047 12.8342 5.39637 12.8342H8.19054C10.0922 12.8342 11.3989 11.3 11.0839 9.42167C10.7514 7.45 8.8497 5.83417 6.84887 5.83417C4.67887 5.83417 2.75387 7.6075 2.57304 9.77167Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.10677 4.37583C6.91219 4.37583 7.5651 3.72292 7.5651 2.9175C7.5651 2.11209 6.91219 1.45917 6.10677 1.45917C5.30136 1.45917 4.64844 2.11209 4.64844 2.9175C4.64844 3.72292 5.30136 4.37583 6.10677 4.37583Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.0924 5.07515C10.7368 5.07515 11.2591 4.55282 11.2591 3.90849C11.2591 3.26416 10.7368 2.74182 10.0924 2.74182C9.44812 2.74182 8.92578 3.26416 8.92578 3.90849C8.92578 4.55282 9.44812 5.07515 10.0924 5.07515Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.25 7.40765C12.7332 7.40765 13.125 7.0159 13.125 6.53265C13.125 6.0494 12.7332 5.65765 12.25 5.65765C11.7668 5.65765 11.375 6.0494 11.375 6.53265C11.375 7.0159 11.7668 7.40765 12.25 7.40765Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.3151 6.24099C2.95944 6.24099 3.48177 5.71865 3.48177 5.07432C3.48177 4.42999 2.95944 3.90765 2.3151 3.90765C1.67077 3.90765 1.14844 4.42999 1.14844 5.07432C1.14844 5.71865 1.67077 6.24099 2.3151 6.24099Z"
        stroke={htmlColor || "currentColor"}
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
